import { ApiClient } from "../config/axiosConfig";
import { ILoginRequest, IUser, IUserInfo } from "../models/Users";

export const authService = {
  login: async (data: ILoginRequest): Promise<IUser> => {
    const res = await ApiClient.POST<IUser>("/auth/login", data);
    return res;
  },
  logout: async () => {
    const res = await ApiClient.POST("/auth/logout");
    return res;
  },
  me: async (): Promise<IUserInfo> => {
    const res = await ApiClient.GET<IUserInfo>("/auth/me");
    return res;
  },
};
